import axios from 'axios';

axios.defaults.headers.post['Content-Type'] = 'application/json';

const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 10000,
  // withCredentials: true,
});

service.interceptors.request.use(
  (config) => {
    if (config.data) {
      let data = null;
      try {
        data = JSON.stringify(config.data);
      } catch (error) {
        data = config.data;
      }
      config.data = data;
    }
    return config;
  },
  error => (Promise.reject(error)),
);

service.interceptors.response.use(
  (response) => {
    if (response.status === 200) {
      return response.data;
    }
    return response;
  },
  error => (Promise.reject(error)),
);

export const get = (api, params) => (service({
    url: api,
    method: 'get',
    params,
}));
  
export const post = (api, params) => (service({
    url: api,
    method: 'post',
    data: params,
}));

export const del = (api, params) => (service({
    url: api,
    method: 'delete',
    data: params,
}));

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js